{
	"title": "Final amount of captured and stored CO2",
	"fuelUsageTitle": "Carbon origin composition",
	"fuelPumpedTitle": "Pumped net to storage CO2",
	"biogenic": "Biogenic",
	"fossil": "Fossil",
	"total": "Total"
}
